import $ from 'jquery';

const moreLessButtons = $('.more-less-button');

moreLessButtons.each(function(index, element) {
    $(element).on('click', function(event) {
        event.preventDefault();

        $(element).prev('.more-hidden').slideToggle('fast', function () {
            if ($(element).attr('data-hidden-display') == 'inline' && $(this).is(':visible')) {
                $(this).css('display','inline');
            }
        });
        
        $(element).toggleClass('flip-arrow');

        const elementText = $(element).find('span');

        elementText.text(elementText.text() === site_data.expand_string ? site_data.swipe_string : site_data.expand_string);
    });
});